/* eslint "import/no-mutable-exports": "off" */
const residenceTypes = {
  DORM: { type: 'DORM', title: 'residence.dorm', intl: true },
  MORTGAGE: { type: 'MORTGAGE', title: 'residence.mortgage', intl: true },
  OTHER: { type: 'OTHER', title: 'residence.other', intl: true },
  OWN: { type: 'OWN', title: 'residence.owner', intl: true },
  OWNER: { type: 'OWNER', title: 'residence.owner', intl: true },
  OWNERHOUSE: { type: 'OWNERHOUSE', title: 'residence.ownerhouse', intl: true },
  OWNERAPARTMENT: { type: 'OWNERAPARTMENT', title: 'residence.ownerapartment', intl: true },
  RENT: { type: 'RENT', title: 'residence.rent', intl: true },
  WITH_PARENT: { type: 'WITH_PARENT', title: 'residence.with_parent', intl: true },
  WITH_PARENTS: { type: 'WITH_PARENTS', title: 'residence.with_parents', intl: true },
  WITHPARENTS: { type: 'WITHPARENTS', title: 'residence.with_parent', intl: true },
  WITH_PARENTS_BOARDING: { type: 'WITH_PARENTS_BOARDING', title: 'residence.with_parents_boarding', intl: true },
};

const eeTypes = [
  residenceTypes.OWNER,
  residenceTypes.RENT,
  residenceTypes.WITH_PARENTS,
  residenceTypes.DORM,
  residenceTypes.OTHER,
];

const ltTypes = [
  residenceTypes.RENT,
  residenceTypes.OWNERHOUSE,
  residenceTypes.OWNERAPARTMENT,
  residenceTypes.WITHPARENTS,
  residenceTypes.DORM,
];

const lvTypes = [
  residenceTypes.OWN,
  residenceTypes.RENT,
  residenceTypes.OTHER,
];

const fiTypes = [
  residenceTypes.RENT,
  residenceTypes.OWN,
  residenceTypes.OTHER,
];

const mxTypes = [
  residenceTypes.RENT,
  residenceTypes.OWN,
  residenceTypes.WITH_PARENT,
];

const esTypes = [
  residenceTypes.RENT,
  residenceTypes.OWN,
  residenceTypes.WITH_PARENT,
  residenceTypes.OTHER,
];

const auTypes = [
  residenceTypes.RENT,
  residenceTypes.OWNER,
  residenceTypes.WITH_PARENTS_BOARDING,
  residenceTypes.MORTGAGE,
  residenceTypes.OTHER,
];

let data = [];

switch (COUNTRY) {
  case 'LV':
    data = data.concat(lvTypes);
    break;
  case 'LT':
    data = data.concat(ltTypes);
    break;
  case 'FI':
    data = data.concat(fiTypes);
    break;
  case 'MX':
    data = data.concat(mxTypes);
    break;
  case 'ES':
    data = data.concat(esTypes);
    break;
  case 'AU':
    data = data.concat(auTypes);
    break;
  default:
    data = data.concat(eeTypes);
}

export default data;
